import { PostMessageTransport } from '..';
/**
 * An object with promises to indicate whether or not that transport is available.
 */
export const availableTransports = {
    extension: PostMessageTransport.isAvailable(),
    availableExtensions: PostMessageTransport.getAvailableExtensions()
};
//# sourceMappingURL=available-transports.js.map